import React from "react";
import "./App.css";
import GameController from './components/GameController';

function App() {
  return (
    <div className="App">
      <GameController />
    </div>
  );
}

export default App;
